import { useEffect, useRef, useState } from 'react';

/**
 * Garde le loader visible pendant `minDuration` puis le laisse se fermer
 * (AnimatePresence / exit Framer Motion).
 */
export function useLoaderTransition(isLoading, { minDuration = 780 } = {}) {
  const mountedAt = useRef(Date.now());
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (isLoading) {
      mountedAt.current = Date.now();
      setVisible(true);
      return undefined;
    }

    const elapsed = Date.now() - mountedAt.current;
    const wait = Math.max(0, minDuration - elapsed);
    const timer = window.setTimeout(() => setVisible(false), wait);
    return () => window.clearTimeout(timer);
  }, [isLoading, minDuration]);

  return isLoading || visible;
}
